module.exports = __webpack_public_path__ + "img/new_index_cases5.c6b01a30.png";